import './projects.css';
import bgImage from '../../assets/bg.jpg';
import data from '../../projects.json';
import ProjectCard from '../../components/ProjectCard/ProjectCard';

const Projects = () => {
  return (
    <>
      <main>
        <img src={bgImage} alt="bgImage" className="bgImage" />
        <div className="projectsContainer">
          {data.map((project) => (
            <ProjectCard key={project.id} project={project} />
          ))}
        </div>
      </main>
    </>
  );
};

export default Projects;
